import { useState, useEffect } from "react";
import { pb } from "../services/pocketbase";

export function useInventory(user) {
  const [inventory, setInventory] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return; // Só carrega se logado

    // --- CARREGAMENTO INICIAL ---
    const fetchInitial = async () => {
      try {
        const [stockData, resData] = await Promise.all([
          pb.collection("inventory_items").getFullList({ sort: "-created" }),
          pb.collection("reservations").getFullList({ sort: "-created" })
        ]);
        
        // Normalização de Statuses Customizados
        const normalizedStock = stockData.map(i => {
          if (i.isPE && i.reason && i.reason.startsWith("pe_")) {
            return { ...i, status: i.reason };
          }
          return i;
        });

        setInventory(normalizedStock);
        setReservations(resData);
        setLoading(false);
      } catch (e) {
        console.error("Erro loading inventory:", e);
        setLoading(false);
      }
    };

    fetchInitial();

    // --- SUBSCRIPTIONS ---

    // 1. Estoque
    pb.collection("inventory_items").subscribe("*", (e) => {
      setInventory(prev => {
        let record = e.record;
        if (record && record.isPE && record.reason && record.reason.startsWith("pe_")) {
          record = { ...record, status: record.reason };
        }
        if (e.action === "delete") return prev.filter(i => i.id !== record.id);
        if (e.action === "create") return [record, ...prev];
        if (e.action === "update") return prev.map(i => i.id === record.id ? record : i);
        return prev;
      });
    }).catch(err => {
      console.warn("⚠️ Realtime inventory_items indisponível:", err?.message || err);
    });

    // 2. Reservas
    pb.collection("reservations").subscribe("*", (e) => {
      setReservations(prev => {
        if (e.action === "delete") return prev.filter(i => i.id !== e.record.id);
        if (e.action === "create") return [e.record, ...prev];
        if (e.action === "update") return prev.map(i => i.id === e.record.id ? e.record : i);
        return prev;
      });
    }).catch(err => {
      console.warn("⚠️ Realtime reservations indisponível:", err?.message || err);
    });

    return () => {
      pb.collection("inventory_items").unsubscribe("*").catch(() => {});
      pb.collection("reservations").unsubscribe("*").catch(() => {});
    };
  }, [user]);

  return { inventory, reservations, loading, setInventory, setReservations };
}
